import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Storage } from '@ionic/storage';
import { DialogData } from 'src/app/common/delete-alert/delete-alert.component';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-batch-stockdetails',
  templateUrl: './batch-stockdetails.component.html',
  styleUrls: ['./batch-stockdetails.component.scss']
})
export class BatchStockdetailsComponent implements OnInit {
  responseData: any;
  loadingTrue = false;
  btnClicked = false;
  GodwonTrue = false;
  nosales = false;
  filterData = {
    itemcode: '',
    searchitem: '',
    itemsperpage: '',
    currentpage: '',
    sortby: 'expdate',
    sorttype: 'asc',
    entryupdatemode: 'NO',
    entryname: 'SALES_INVOICE',
    entryno: '',
    entrybranchcode: '',
    entryfinyearcode: '',
    godowncode: '',
    bc: ''
  };
  singleSelect = {
    batchno: '',
    salerate: '',
    godowndetails: [],
  };
  type = '';
  items = [];
  searchTimeout: any;
  ic = '';
  qty: any = '';
  selection = [];
  xindex = 0;
  totalstocks = '';
  searchitem = '';
  datas = {
    pricelistname1: {
      required: 'NO',
      caption: ''
    },
    pricelistname2: {
      required: 'NO',
      caption: ''
    },
    pricelistname3: {
      required: 'NO',
      caption: ''
    },
    pricelistname4: {
      required: 'NO',
      caption: ''
    },
    pricelistname5: {
      required: 'NO',
      caption: ''
    },
    pricelistname6: {
      required: 'NO',
      caption: ''
    },
  };
  scanbarcode = '';
  bc = '';
  barcode = '';
  bbc = '';
  bcid = '';
  constructor(
    public dialogRef: MatDialogRef<BatchStockdetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public xdata: DialogData,
    public data: DataService,
    public storage: Storage
  ) {
    this.responseData = this.xdata;
    this.ic = this.responseData.ic;
    this.qty = this.responseData.qty;
    this.filterData.entryname = this.responseData.entryname;
    if (this.responseData.godowncode) {
      this.filterData.godowncode = this.responseData.godowncode;
    }
    if (this.responseData.nosales) {this.nosales = true}
    this.scanbarcode = this.responseData.scanbarcode;
    this.bc = this.responseData.bc;
    this.barcode = this.responseData.barcode;
    this.bbc = this.responseData.bbc;
    if (this.scanbarcode === 'SCANBARCODE') {
      this.filterData.bc = this.bc;
    } else if (this.barcode === 'BARCODE') {
      this.filterData.bc = this.bbc
    } else {
      this.filterData.bc = '';
    }
   }

  ngOnInit() {
    this.getPriceList();
    this.xindex = this.responseData.index;
    this.getData(true);
    if (this.data.authorizationResponse.edition_features.multiwarehouses === 'YES' && this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.filterData.godowncode === '') {
      this.GodwonTrue = true;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  goNext(): void {
    this.dialogRef.close({
      selectedbill: this.singleSelect,
      qty: this.qty,
      select : true,
    });
  }

  getData(val): void {
    if (this.data.token !== '') {
      this.loadingTrue = true;
      this.filterData.itemcode = this.ic;
      this.data.postData('batchstockdetails', this.filterData).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.items = this.responseData.data;
          this.totalstocks = this.responseData.totalstocks;
          this.items.forEach(element => {
            element.viewgodwon = false;
            element.godowndetails.forEach(element2 => {
              // element2.stock = element2.stock;
              element2.qty = '0';
            });
            // list.godowndetails = element.godowndetails;
          });
        } else { }
        this.loadingTrue = false;
      }, (error) => { });
    }
  }

  select(val) {
    if (val.batchno != this.singleSelect.batchno) {
      this.showGodwon(val);
    }
    this.singleSelect = val;
  }
  selectbatch(val) {
    if (this.GodwonTrue === false) {
      this.singleSelect = val;
      this.goNext();
    } else {
      if (val.batchno != this.singleSelect.batchno) {
        this.singleSelect = val;
        this.showGodwon(val);
      }
    }
  }
  isSelected(val) {
    if (this.selection.length > 0) {
      const index = this.selection.map(c => c.batchno).indexOf(val.batchno);
      if (index === -1) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  
  showGodwon(val) {
    this.items.forEach(element => {
      if (val.batchno === element.batchno) {
        element.viewgodwon = true;
      } else {
        element.viewgodwon = false;
        this.qty = 0;
        element.godowndetails.forEach(element2 => {
          element2.qty = '0';
        });
      }
    });
  }

  getqty(val, godn) {
    this.singleSelect = val;
    this.qty = 0;
    if (godn.qty === '') { godn.qty = '0'; } 
    if (parseFloat(godn.qty) > parseFloat(godn.stock)) {this.data.openAlertFalse('Qty is more then Avilable Stock');}
    val.godowndetails.forEach(element2 => {
      this.qty = this.qty + parseFloat(element2.qty);
    });
  }
  
  verify() {
    let test = false;
    if (this.singleSelect.batchno === '') {
      this.goNext();
    } else {
      this.items.forEach(element => {
        element.godowndetails.forEach(element2 => {
          if (element2.qty != '0' && element2.qty != '' && element2.qty != 0) {
            test = true;
            if (parseFloat(element2.qty) <= parseFloat(element2.stock)) {
              this.goNext();
            } else {this.data.openAlertFalse('Qty is more then Avilable stock');}
          } else {
            setTimeout(() => {
              if (!test) {
                this.data.openAlertFalse('please add Godown Qty');
              }
            }, 800);
          }
        });
      });
    }
  }

  getPriceList() {
    this.storage.get('pricelist').then((val) => {
      if (val) {
        this.datas = val;
      }
    });
  }


}
